import { useSelector } from 'react-redux';
import { useTheme } from 'uinix-ui';

import { slices } from '~/redux/slices';

import {
  COLLAPSED_WIDTH,
  RIGHT_DETAILS_PANEL_WIDTH,
} from '../chat-bot-panel/constants';
import { testIsFieldCitation } from '../utils/citations';

/**
 * Custom hook to get the Ask AI sidepanel width from Redux store
 * @returns {string} The current width of the chatbot sidepanel
 */
export const useAskAISidepanel = () => {
  const theme = useTheme();
  const leftContentWidth = theme.sizes['sideContent.width'] as number;
  const panelMode = useSelector(slices.chatbot.selectors.selectPanelMode);
  const isAskAiVisible = useSelector(
    slices.chatbot.selectors.selectIsChatbotVisible,
  );
  const activeCitation = useSelector(
    slices.chatbot.selectors.selectActiveCitation,
  );
  const isRightContentVisible =
    !!activeCitation && testIsFieldCitation(activeCitation);
  const isSideContentVisible = useSelector(
    slices.chatbot.selectors.selectIsSideContentVisible,
  );

  const sidePanelWidth = getSidePanelWidth(
    panelMode,
    isSideContentVisible,
    isRightContentVisible,
    leftContentWidth,
  );

  return {
    isVisible: isAskAiVisible,
    width: sidePanelWidth,
  };
};

const getSidePanelWidth = (
  panelMode: 'floating' | 'floating-full-width' | 'floating-sidepanel',
  isSideContentVisible: boolean,
  isRightContentVisible: boolean,
  leftContentWidth: number,
) => {
  if (panelMode === 'floating-full-width') {
    return 'fill';
  }
  let width = COLLAPSED_WIDTH + 25;
  if (isSideContentVisible) width += leftContentWidth;
  if (isRightContentVisible) width += RIGHT_DETAILS_PANEL_WIDTH;
  return width;
};
